import CreateColumn from '../../../../Services/agGrid/createColumn';

const headerWrap = { wrapHeaderText: true, headerClass: 'ag-header-cell-wrap' };

const FormatYmdCell = (params) => {
  if (!params.value) return '';
  const d = new Date(params.value);
  if (Number.isNaN(d.getTime())) return String(params.value);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** GetPerNewR3_Daily / GetSamBasic02R5_Daily 계산 Status → 세부 그리드 표시 */
const GetDetailStatusText = (row) => {
  const status = String(
    row?.listStatus ??
      row?.ListStatus ??
      row?.status ??
      row?.Status ??
      ''
  ).trim();
  return status || '—';
};

/**
 * M_PER_NEW PermitList.js `statusBadgeClass` — Tailwind → 배경 hex (모바일과 동일)
 * primary(#5abd4f) 포함
 */
const DETAIL_STATUS_BADGE_BG = {
  반려: '#f87171',
  연장반려: '#f43f5e',
  만료: '#0f172a',
  결재요청: '#5abd4f',
  승인요청: '#059669',
  승인: '#6366f1',
  결재대기: '#60a5fa',
  결재완료: '#6366f1',
  연장요청: '#93c5fd',
  연장대기: '#f472b6',
  입회요청: '#f97316',
  입회중: '#f59e0b',
  작업완료: '#94a3b8',
  대기: '#cbd5e1',
  완료: '#94a3b8',
  승인완료: '#6366f1',
  서명완료: '#6366f1',
};

const DETAIL_STATUS_BADGE_FALLBACK_BG = '#64748b';

const GetDetailStatusCellStyle = (row) => {
  const txt = GetDetailStatusText(row);
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    minWidth: '100%',
    minHeight: '28px',
    borderRadius: 4,
    padding: '2px 6px',
    boxSizing: 'border-box',
    textAlign: 'center',
    lineHeight: 1.3,
  };

  if (txt === '—') {
    return { ...base, backgroundColor: 'transparent', color: '#000' };
  }

  const backgroundColor =
    DETAIL_STATUS_BADGE_BG[txt] ?? DETAIL_STATUS_BADGE_FALLBACK_BG;

  return { ...base, backgroundColor, color: '#fff' };
};

/**
 * SAM_BASIC_02 마스터 그리드(좌)
 * GetSamBasic02R4: PM_CD 1행 — ReqNm, createDate, TotalStartDate, TotalEndDate (결재·반려이력은 상세)
 */
export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'center', 72, false, false, false, 'checkbox', {
      minWidth: 72,
      maxWidth: 88,
      flex: 0,
      checkboxProps: {
        DeleteNewRow1: props.DeleteNewRow1,
        RestoreRow1: props.RestoreRow1,
        gridRef1: props.gridRef1,
        rowData1: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
    }),
    CreateColumn('reqNm', '신청자', 'left', 130, false, false, false, 'text', {
      minWidth: 120,
      flex: 2,
    }),
    CreateColumn(
      'createDate',
      '신청일자',
      'center',
      120,
      false,
      false,
      false,
      'text',
      {
        minWidth: 110,
        flex: 1,
        ...headerWrap,
        valueGetter: (params) =>
          params.data?.createDate ??
          params.data?.CreateDate ??
          params.data?.CREATE_DATE ??
          '',
        valueFormatter: FormatYmdCell,
      }
    ),
    CreateColumn(
      'totalStartDate',
      '작업시작일자',
      'center',
      120,
      false,
      false,
      false,
      'text',
      {
        minWidth: 110,
        flex: 1,
        ...headerWrap,
        valueGetter: (params) =>
          params.data?.totalStartDate ?? params.data?.TotalStartDate ?? '',
        valueFormatter: FormatYmdCell,
      }
    ),
    CreateColumn(
      'totalEndDate',
      '작업종료일자',
      'center',
      120,
      false,
      false,
      false,
      'text',
      {
        minWidth: 110,
        flex: 1,
        ...headerWrap,
        valueGetter: (params) =>
          params.data?.totalEndDate ?? params.data?.TotalEndDate ?? '',
        valueFormatter: FormatYmdCell,
      }
    ),
    CreateColumn(
      'pmCd',
      '작업허가서코드',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        hide: true,
        valueGetter: (params) =>
          params.data?.pmCd || params.data?.PmCd || params.data?.PM_CD || '',
      }
    ),
    CreateColumn(
      'workDate',
      '작업일자(상세조회)',
      'center',
      100,
      false,
      false,
      true,
      'text',
      {
        hide: true,
        valueGetter: (params) =>
          params.data?.workDate ??
          params.data?.WorkDate ??
          params.data?.createDate ??
          '',
      }
    ),
    CreateColumn(
      'smId',
      '안전관리자ID',
      'left',
      1,
      false,
      false,
      true,
      'text',
      { hide: true }
    ),
    CreateColumn('smSign', 'SM서명', 'left', 1, false, false, true, 'text', {
      hide: true,
    }),
    CreateColumn(
      'returnYn',
      '반려여부',
      'left',
      1,
      false,
      false,
      true,
      'text',
      { hide: true }
    ),
    CreateColumn('depSign', '부서서명', 'left', 1, false, false, true, 'text', {
      hide: true,
    }),
    CreateColumn(
      'currentUserDepSigned',
      '현재사용자부서서명',
      'left',
      1,
      false,
      false,
      true,
      'text',
      { hide: true }
    ),
    CreateColumn(
      'signedDepSignCount',
      '부서서명완료수',
      'left',
      1,
      false,
      false,
      true,
      'text',
      { hide: true }
    ),
    CreateColumn(
      'totalDepSignCount',
      '부서서명총수',
      'left',
      1,
      false,
      false,
      true,
      'text',
      { hide: true }
    ),
    CreateColumn(
      'userId',
      '사용자ID',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        hide: true,
        valueGetter: (params) =>
          params.data?.userId || params.data?.USER_ID || '',
      }
    ),
    CreateColumn(
      'custCd',
      '사업장코드',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        hide: true,
      }
    ),
    CreateColumn('mapBlob', '블롭', 'left', 100, false, false, true, 'text', {
      hide: true,
    }),
    CreateColumn('mapFile', '파일', 'left', 100, false, false, true, 'text', {
      hide: true,
    }),
    CreateColumn(
      'mapFileName',
      '파일명(사용자가 올린 이름)',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        hide: true,
      }
    ),
    CreateColumn(
      'saveName',
      '파일명(저장되는 이름)',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        hide: true,
      }
    ),
  ];
};

/** GetPerNewR3 Detail — 작업종류·업체·일자·시간·연장종료 (우측 상세 그리드) */
export const getColumnDefsDetail = () => {
  return [
    CreateColumn('_sel', '', 'center', 48, false, false, false, 'checkbox', {
      maxWidth: 52,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      sortable: false,
      filter: false,
      suppressMovable: true,
    }),
    CreateColumn(
      'workDate',
      '작업일자',
      'center',
      118,
      false,
      false,
      false,
      'text',
      {
        width: 118,
        valueGetter: (params) =>
          params.data?.workDate ?? params.data?.WorkDate ?? '',
        valueFormatter: FormatYmdCell,
      }
    ),
    CreateColumn(
      'workTypeNm',
      '작업종류',
      'center',
      160,
      false,
      false,
      false,
      'text',
      {
        minWidth: 120,
        valueGetter: (params) =>
          params.data?.workTypeNm ??
          params.data?.WorkTypeNm ??
          params.data?.WORK_TYPE_NM ??
          '',
      }
    ),
    CreateColumn(
      'detailStatus',
      '상태',
      'center',
      120,
      false,
      false,
      false,
      'text',
      {
        minWidth: 100,
        cellStyle: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2px 4px',
        },
        valueGetter: (params) => GetDetailStatusText(params.data),
        cellRenderer: (params) => {
          const txt = GetDetailStatusText(params.data);
          const style = GetDetailStatusCellStyle(params.data);
          return <span style={style}>{txt}</span>;
        },
      }
    ),
    CreateColumn(
      'strTime',
      '작업\n시작시간',
      'center',
      72,
      false,
      false,
      false,
      'text',
      {
        width: 72,
        ...headerWrap,
        valueGetter: (params) =>
          params.data?.strTime ?? params.data?.StrTime ?? '',
      }
    ),
    CreateColumn(
      'endTime',
      '작업\n종료시간',
      'center',
      72,
      false,
      false,
      false,
      'text',
      {
        width: 72,
        ...headerWrap,
        valueGetter: (params) =>
          params.data?.endTime ?? params.data?.EndTime ?? '',
      }
    ),
    CreateColumn(
      'extEndTime',
      '연장시간',
      'center',
      88,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 72,
        valueGetter: (params) =>
          params.data?.extEndTime ??
          params.data?.ExtEndTime ??
          params.data?.EXT_END_TIME ??
          params.data?.ext_end_time ??
          params.data?.extensionEndTime ??
          params.data?.ExtensionEndTime ??
          '',
      }
    ),
    CreateColumn('dailyCd', '일일키', 'left', 1, false, false, true, 'text', {
      hide: true,
      valueGetter: (params) =>
        params.data?.dailyCd ?? params.data?.DailyCd ?? '',
    }),
    CreateColumn(
      'workItemId',
      '작업항목ID',
      'left',
      1,
      false,
      false,
      true,
      'text',
      {
        hide: true,
        valueGetter: (params) =>
          params.data?.workItemId ?? params.data?.WorkItemId ?? '',
      }
    ),
    CreateColumn('dtlCd', '상세키', 'left', 1, false, false, true, 'text', {
      hide: true,
      valueGetter: (params) =>
        params.data?.dtlCd ?? params.data?.DtlCd ?? params.data?.DTL_CD ?? '',
    }),
  ];
};

// 반려이력 그리드 컬럼 정의
export const getColumnDefs2 = () => {
  return [
    CreateColumn(
      'returnNm',
      '반려자',
      'left',
      150,
      false,
      false,
      false,
      'text',
      {
        width: 150,
        valueGetter: (params) => params.data?.returnNm || '',
      }
    ),
    CreateColumn(
      'returnDate',
      '반려일시',
      'left',
      130,
      false,
      false,
      false,
      'text',
      {
        width: 130,
        valueGetter: (params) => params.data?.returnDate || '',
        valueFormatter: (params) => {
          if (!params.value) return '';
          const date = new Date(params.value);
          return date.toISOString().split('T')[0]; // 'YYYY-MM-DD' 형식
        },
      }
    ),
    CreateColumn(
      'returnDetail',
      '반려내용',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        valueGetter: (params) => params.data?.returnDetail || '',
      }
    ),
  ];
};

export default getColumnDefs1;
